import { render, staticRenderFns } from "./toilet.vue?vue&type=template&id=8b6737d8&scoped=true"
import script from "./toilet.vue?vue&type=script&lang=js"
export * from "./toilet.vue?vue&type=script&lang=js"
import style0 from "./toilet.vue?vue&type=style&index=0&id=8b6737d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6737d8",
  null
  
)

export default component.exports